import thumbnailProam from "../images/thumbnails/proam.png";
import thumbnailDivision1 from "../images/thumbnails/division-1.png";
import thumbnailDivision2 from "../images/thumbnails/division-2.png";
import thumbnailDivision3 from "../images/thumbnails/division-3.png";
import thumbnailDivision4 from "../images/thumbnails/division-4.png";
import thumbnailDivision5 from "../images/thumbnails/division-5.png";
import thumbnailDivision6 from "../images/thumbnails/division-6.png";
import thumbnailU16 from "../images/thumbnails/u16.png";
import thumbnailU14 from "../images/thumbnails/u14.png";
import thumbnailU12 from "../images/thumbnails/u12.png";

import startingFiveProam from "../images/starting-five/proam.png";
import startingFiveDivision1 from "../images/starting-five/division-1.png";
import startingFiveDivision2 from "../images/starting-five/division-2.png";
import startingFiveDivision3 from "../images/starting-five/division-3.png";
import startingFiveDivision4 from "../images/starting-five/division-4.png";
import startingFiveDivision5 from "../images/starting-five/division-5.png";
import startingFiveDivision6 from "../images/starting-five/division-6.png";
import startingFiveHkkba from "../images/starting-five/hkkba.png";
import startingFiveU16 from "../images/starting-five/u-16.png";
import startingFiveU14 from "../images/starting-five/u-14.png";
import startingFiveU12 from "../images/starting-five/u-12.png";

const DEFAULT_THUMBNAIL_FONT_COLOR = "FFCC99";
const DEFAULT_STARTING_FIVE_FONT_COLOR = "white";
const DEFAULT_STARTING_FIVE_MATCH_NAME_COLOR = "white";

const division1Visual = {
  thumbnail: thumbnailDivision1,
  thumbnailFontColor: "99FFFF",
  startingFive: startingFiveDivision1,
};

const division2Visual = {
  thumbnail: thumbnailDivision2,
  thumbnailFontColor: "FFFFFF",
  startingFive: startingFiveDivision2,
  startingFiveFontColor: "black",
  startingFiveMatchNameColor: "black",
};

const division3Visual = {
  thumbnail: thumbnailDivision3,
  thumbnailFontColor: "8dc3fd",
  startingFive: startingFiveDivision3,
};

const division4Visual = {
  thumbnail: thumbnailDivision4,
  thumbnailFontColor: "1bf9e3",
  startingFive: startingFiveDivision4,
};

const division5Visual = {
  thumbnail: thumbnailDivision5,
  thumbnailFontColor: "FFCC33",
  startingFive: startingFiveDivision5,
};

const division6Visual = {
  thumbnail: thumbnailDivision6,
  startingFive: startingFiveDivision6,
};

const proamVisual = {
  thumbnail: thumbnailProam,
  thumbnailFontColor: "FFFF00",
  startingFive: startingFiveProam,
  startingFiveFontColor: "black",
};

const u16Visual = {
  thumbnail: thumbnailU16,
  startingFive: startingFiveU16,
};

const u14Visual = {
  thumbnail: thumbnailU14,
  startingFive: startingFiveU14,
};

const u12Visual = {
  thumbnail: thumbnailU12,
  startingFive: startingFiveU12,
};

const leagueVisualsByAbv = {
  "Sketch Pro Am": proamVisual,
  "SKETCH Pro-Am": proamVisual,
  "Pro-Amateur": proamVisual,
  "Joint Dynamics D1": division1Visual,
  "Corporate D1": division1Visual,
  "Division 1": division1Visual,
  "Masterwook D2": division2Visual,
  "Corporate D2": division2Visual,
  "Refundz D3": division3Visual,
  "Sketch D3": division3Visual,
  "Division-3": division3Visual,
  "Zanchee D4": division4Visual,
  "Sketch D4": division4Visual,
  "Zerve D5": division5Visual,
  "Sketch D6": division6Visual,
  HKKBL: {
    startingFive: startingFiveHkkba,
  },
  WHKKBL: {
    startingFive: startingFiveHkkba,
  },
  "U-16": u16Visual,
  U16: u16Visual,
  "U16 Girls": u16Visual,
  "U-14 D1": u14Visual,
  "U-14 D2": u14Visual,
  "U14 D1": u14Visual,
  "U14 D2": u14Visual,
  "U14 Spring Invitational": u14Visual,
  "U-12 D1": u12Visual,
  "U-12 D2": u12Visual,
  "U12 ": u12Visual,
  "서울삼성리틀썬더스 U-12": u12Visual,
  "서울삼성리틀썬더스 U-14": u14Visual,
};

const leagueVisualPatterns = [
  { pattern: /pro[\s-]?am/i, visual: proamVisual },
  {
    pattern: /\bd1\b|division[\s-]?1|joint dynamics/i,
    visual: division1Visual,
  },
  { pattern: /\bd2\b|division[\s-]?2|masterwook/i, visual: division2Visual },
  {
    pattern: /\bd3\b|division[\s-]?3|refundz|sketch d3/i,
    visual: division3Visual,
  },
  {
    pattern: /\bd4\b|division[\s-]?4|zanchee|sketch d4/i,
    visual: division4Visual,
  },
  { pattern: /\bd5\b|division[\s-]?5|zerve/i, visual: division5Visual },
  { pattern: /\bd6\b|division[\s-]?6|sketch d6/i, visual: division6Visual },
  { pattern: /\bu[\s-]?16\b/i, visual: u16Visual },
  { pattern: /\bu[\s-]?14\b/i, visual: u14Visual },
  { pattern: /\bu[\s-]?12\b/i, visual: u12Visual },
  { pattern: /hkkbl/i, visual: { startingFive: startingFiveHkkba } },
];

const defaultVisual = {
  thumbnailImage: null,
  thumbnailFontColor: DEFAULT_THUMBNAIL_FONT_COLOR,
  startingFiveImage: null,
  startingFiveFontColor: DEFAULT_STARTING_FIVE_FONT_COLOR,
  startingFiveMatchNameColor: DEFAULT_STARTING_FIVE_MATCH_NAME_COLOR,
};

function toResolvedVisual(config) {
  if (!config) {
    return defaultVisual;
  }

  return {
    thumbnailImage: config.thumbnail ?? null,
    thumbnailFontColor:
      config.thumbnailFontColor ?? DEFAULT_THUMBNAIL_FONT_COLOR,
    startingFiveImage: config.startingFive ?? null,
    startingFiveFontColor:
      config.startingFiveFontColor ?? DEFAULT_STARTING_FIVE_FONT_COLOR,
    startingFiveMatchNameColor:
      config.startingFiveMatchNameColor ??
      DEFAULT_STARTING_FIVE_MATCH_NAME_COLOR,
  };
}

export function getLeagueVisuals(leagueAbv) {
  if (!leagueAbv) {
    return defaultVisual;
  }

  const trimmedLeagueAbv = leagueAbv.trim();
  const exactMatch = leagueVisualsByAbv[trimmedLeagueAbv];

  if (exactMatch) {
    return toResolvedVisual(exactMatch);
  }

  const patternMatch = leagueVisualPatterns.find(({ pattern }) =>
    pattern.test(trimmedLeagueAbv)
  );

  if (patternMatch) {
    return toResolvedVisual(patternMatch.visual);
  }

  return defaultVisual;
}
